export class RetrieveThemeCommand {
    communityId: string;

    public constructor(attributes?: Partial<RetrieveThemeCommand>) {
        Object.assign(this, attributes);
    }
}
